interface Props {
  size?: number;
  color?: string;
}

const QuestionIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        fill={color}
        d="M24 11.043v1.925c-.016.023-.042.045-.046.07q-.096.583-.188 1.17c-.16 1.012-.495 1.97-.92 2.897a11.6 11.6 0 0 1-1.91 2.891 11.8 11.8 0 0 1-2.094 1.847 12 12 0 0 1-2.736 1.437c-.867.317-1.758.55-2.684.628-.177.015-.35.06-.526.092h-1.873c-.047-.016-.092-.04-.14-.048-.475-.066-.96-.093-1.425-.2-1.237-.289-2.417-.734-3.516-1.385a11.95 11.95 0 0 1-5.155-6.094C.363 15.16.09 14.017.024 12.839c-.059-1.093-.018-2.189.214-3.273C.5 8.34.916 7.173 1.53 6.09c.74-1.308 1.664-2.482 2.87-3.396a18 18 0 0 1 1.938-1.309A9.1 9.1 0 0 1 9.121.336C9.715.22 10.31.091 10.91.024c.454-.05.92-.005 1.38-.013.657-.01 1.3.07 1.946.184 1 .175 1.952.497 2.868.922a11.4 11.4 0 0 1 2.75 1.802c.658.58 1.253 1.214 1.777 1.919a11.7 11.7 0 0 1 1.471 2.615c.373.93.645 1.888.76 2.888.026.237.09.47.137.703M11.777 5.926c-.391.063-.792.091-1.17.196-.913.255-1.61.773-1.863 1.74a.82.82 0 0 0 .25.84c.245.229.547.383.867.219.212-.11.398-.304.543-.5.231-.31.491-.567.883-.609.3-.032.61-.03.912-.002.773.072 1.255.766.902 1.51-.22.465-.614.757-.995 1.057-.39.308-.753.631-.991 1.074-.188.351-.286.724-.338 1.121-.048.374-.07.742.068 1.086.062.156.229.309.386.38.306.136.635.065.934-.054.19-.075.364-.2.36-.457-.003-.168.042-.336.04-.504a1.64 1.64 0 0 1 .522-1.255c.38-.364.792-.695 1.156-1.075.604-.63.996-1.365.948-2.277-.039-.728-.367-1.305-.94-1.734-.729-.545-1.572-.726-2.474-.756m1.07 10.462c-.014-.688-.51-1.192-1.251-1.211-.6-.016-1.213.591-1.175 1.214.04.654.451 1.195 1.191 1.222.637.023 1.258-.553 1.235-1.226"
      ></path>
    </svg>
  );
};

export default QuestionIcon;
